import { render, staticRenderFns } from "./EnviarImagemComp.vue?vue&type=template&id=b68f3efc&"
import script from "./EnviarImagemComp.vue?vue&type=script&lang=js&"
export * from "./EnviarImagemComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EnviarImagemComp.vue"
export default component.exports